import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import PropTypes from 'prop-types';
import { affiliateStatus, blogStatus } from '../../configs/Constants';

const getColorDetails = (value) => {
  switch (value) {
    case affiliateStatus.APPROVED:
      return 'rgb(56, 142, 60)';
    case affiliateStatus.PENDING:
      return 'rgb(245, 124, 0)';
    case affiliateStatus.DISAPPROVED:
      return 'rgb(211, 47, 47)';
    default:
      return '#5A5A5A';
  }
};

const Status = ({ value, statusFor }) => {
  const colorDetails = getColorDetails(value);

  return (
    <Box
      sx={{
        color: colorDetails,
        backgroundColor: alpha(colorDetails, 0.1),
        width: 100,
        borderRadius: 2,
        paddingY: '1px',
        textAlign: 'center',
      }}
    >
      {statusFor === 'blog' && <Typography>{blogStatus[value]}</Typography>}
      {statusFor === 'affiliate' && <Typography>{affiliateStatus[value]}</Typography>}
    </Box>
  );
};

Status.propTypes = {
  value: PropTypes.number.isRequired,
  statusFor: PropTypes.string.isRequired,
};

export default Status;
